import { Tag, TagLeftIcon, TagLabel } from '@chakra-ui/react';
import { useRef } from 'react';
import Picker1 from '../../../../../../core/components/pickers/Picker1';
import { CustomDivider } from '../../../../../../core/components/pickers/types';
import { BsCalendarDate } from 'react-icons/bs';
import { CiBoxList, CiRuler } from 'react-icons/ci';
import { FaIcons, FaTable } from 'react-icons/fa';
import { MdTextFields } from 'react-icons/md';
import { TbCheckbox, TbNumbers } from 'react-icons/tb';
import { ValidationCriteria } from '../../../../../../sheet/types';
import { IoMdCheckbox, IoMdCheckboxOutline } from 'react-icons/io';
import { LuFiles } from 'react-icons/lu';
import { SiIcons8 } from 'react-icons/si';

interface CriteriaPickerProps<T> {
  criteria: T;
  changeCriteria(criteria: T): void;
}
const CriteriaPicker = ({
  criteria,
  changeCriteria,
}: CriteriaPickerProps<ValidationCriteria>) => {
  const criteriaOptions = getCriteriaOptions();
  const selectedRef = useRef<HTMLButtonElement | null>(null);

  const CriteriaButton = (
    <Tag variant="outline" colorScheme="blue" rounded="2xl">
      <TagLeftIcon as={getCriteriaIcon(criteria)} />
      <TagLabel>Criteria</TagLabel>
    </Tag>
  );

  const menu = (
    <Picker1.Menu ref={selectedRef}>
      <Picker1.MenuButton Icon={CriteriaButton} title={criteria} />
      <Picker1.MenuList<ValidationCriteria>
        selectedRef={selectedRef}
        selectedValue={criteria}
        options={criteriaOptions}
        changeValue={changeCriteria}
      />
    </Picker1.Menu>
  );

  return menu;
};

export default CriteriaPicker;

// #region helpers
const getCriteriaIcon = (criteria: ValidationCriteria) => {
  switch (criteria) {
    case ValidationCriteria.List:
      return CiBoxList;
    case ValidationCriteria.CellRange:
      return FaTable;
    case ValidationCriteria.Number:
      return TbNumbers;
    case ValidationCriteria.Date:
      return BsCalendarDate;
    case ValidationCriteria.TextLength:
      return CiRuler;
    case ValidationCriteria.Text:
      return MdTextFields;
    case ValidationCriteria.Checkbox:
      return TbCheckbox;
    case ValidationCriteria.Files:
      return LuFiles;
    case ValidationCriteria.IconSets:
      return FaIcons;
  }
};

const getCriteriaOptions = (): Array<ValidationCriteria | CustomDivider> => [
  ...Object.values(ValidationCriteria),
];
// #endregion
